import { AppStorage } from './app.storage'

class AuthStorage extends AppStorage{}
export default new AuthStorage( '__oauth__' )


// WEBPACK FOOTER //
// ./src/storage/auth.storage.js